import { render } from "./sales-list.vue?vue&type=template&id=0c4ee710"
import script from "./sales-list.vue?vue&type=script&lang=js"
export * from "./sales-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__